import { useWebsiteSettings } from 'client/store'
import React from 'react'
import { useUpdateStoreObjectProp } from 'src/editor/shared/hooks/use-update-store'
import { WebsiteLayoutGroup } from 'src/editor/shared/settings/wrappers/website-layout-group'
import { updateWebsiteStylesLayout } from 'src/editor/store/website-settings/website-settings-actions'
import { getWebsiteStylesLayout } from 'src/editor/store/website-settings/website-settings-selector'
import { WebsiteLayoutSettings } from 'src/shared/types/website-settings-types'

export const WebsiteStylesSettingsLayout = () => {
  const layout = useWebsiteSettings(getWebsiteStylesLayout)
  const updateLayout = useUpdateStoreObjectProp(
    layout as Partial<WebsiteLayoutSettings>,
    updateWebsiteStylesLayout,
  )

  return (
    <>
      {layout && (
        <WebsiteLayoutGroup layout={layout} updateLayout={updateLayout} />
      )}
    </>
  )
}
